export const isValidTimeValue = date => {
  return date instanceof Date && !isNaN(date)
}
